import { Tab as MuiTab } from '@mui/material';
import { styled } from '@mui/material/styles';

import { typography13MediumStyle } from 'src/legacy/components/Text';
import ColorUtils from 'src/utils/ColorUtils';

export const BaseTab = styled(MuiTab)(({ theme }) => ({
  padding: 0,
  minWidth: 'initial',
  marginRight: theme.spacing(5),
  textTransform: 'none',
  ...typography13MediumStyle,
  color: 'inherit',
  opacity: 0.7,
  '&.Mui-selected': {
    overflow: 'visible',
    position: 'relative',
    color: theme.palette.primary.main,
    opacity: 1,
    '&::after': {
      position: 'absolute',
      left: 0,
      bottom: '-1px',
      width: '100%',
      height: '1px',
      borderBottom: `1px solid ${
        ColorUtils.GetColorDarknessShades(theme.palette.primary.main).dark
      }`,
      content: '""',
    },
  },
  '& .MuiTab-iconWrapper': {
    marginBottom: 0,
  },
  '&.Mui-disabled': {
    color: 'inherit',
    opacity: 0.5,
  },
}));
